// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Support Message (Chat) Page */
.support-message-page .dashboard-body {
  padding-bottom: 2rem;
}

.support-message-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding: 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text, #1e293b);
  background: none;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
}

.support-message-back:hover {
  opacity: 0.8;
}

.support-message-layout {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 1.5rem;
  align-items: start;
}

.support-message-description-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.support-message-card-title {
  margin: 0;
  padding: 0.85rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-muted, #64748b);
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.support-message-description-text {
  margin: 0;
  padding: 1.25rem;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--text, #1e293b);
  text-align: center;
}

.support-message-chat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  min-height: 420px;
}

.support-message-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.support-message-chat-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.support-message-chat-email {
  font-size: 0.9rem;
  color: var(--text-muted, #64748b);
}

.support-message-chat-userid {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ea580c;
}

.support-message-chat-actions {
  display: flex;
  gap: 0.5rem;
}

.support-message-btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.support-message-btn:hover {
  opacity: 0.95;
}

.support-message-btn--close {
  background: #dc2626;
  color: #fff;
}

.support-message-btn--resolve {
  background: #16a34a;
  color: #fff;
}

.support-message-chat-body {
  flex: 1 1;
  padding: 1.25rem;
  overflow-y: auto;
  min-height: 200px;
  max-height: 360px;
}

.support-message-chat-empty {
  margin: 0;
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
  text-align: center;
  padding: 2rem;
}

.support-message-bubble-wrap {
  margin-bottom: 1rem;
}

.support-message-bubble-wrap--user {
  display: flex;
  justify-content: flex-end;
}

.support-message-bubble-wrap--support {
  display: flex;
  justify-content: flex-start;
}

.support-message-bubble {
  max-width: 85%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
}

.support-message-bubble--user {
  background: #fff;
  border: 1px solid #e2e8f0;
}

.support-message-bubble--support {
  background: #475569;
  color: #fff;
  border: none;
}

.support-message-bubble-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
  color: var(--text-muted, #64748b);
}

.support-message-bubble--support .support-message-bubble-label {
  color: rgba(255, 255, 255, 0.85);
}

.support-message-bubble-text {
  margin: 0 0 0.35rem;
  font-size: 0.9rem;
  line-height: 1.4;
}

.support-message-bubble-time {
  font-size: 0.7rem;
  color: var(--text-muted, #94a3b8);
}

.support-message-bubble--support .support-message-bubble-time {
  color: rgba(255, 255, 255, 0.7);
}

.support-message-compose {
  border-top: 1px solid #e2e8f0;
  padding: 1rem 1.25rem;
  background: #f8fafc;
}

.support-message-toolbar {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

.support-message-toolbar-select {
  padding: 0.35rem 0.5rem;
  font-size: 0.8rem;
  font-family: inherit;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  margin-right: 0.5rem;
}

.support-message-toolbar-btn {
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
  color: #64748b;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
}

.support-message-toolbar-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.support-message-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  resize: vertical;
  min-height: 80px;
  margin-bottom: 0.75rem;
}

.support-message-textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.support-message-send-wrap {
  display: flex;
  justify-content: flex-end;
}

.support-message-btn-send {
  padding: 0.6rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.support-message-btn-send:hover:not(:disabled) {
  opacity: 0.95;
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
}

.support-message-btn-send:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .support-message-layout {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Support/SupportMessagePage.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Support Message (Chat) Page */\n.support-message-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.support-message-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  padding: 0.5rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text, #1e293b);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.support-message-back:hover {\n  opacity: 0.8;\n}\n\n.support-message-layout {\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n.support-message-description-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.support-message-card-title {\n  margin: 0;\n  padding: 0.85rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-muted, #64748b);\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.support-message-description-text {\n  margin: 0;\n  padding: 1.25rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: var(--text, #1e293b);\n  text-align: center;\n}\n\n.support-message-chat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  min-height: 420px;\n}\n\n.support-message-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.support-message-chat-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.support-message-chat-email {\n  font-size: 0.9rem;\n  color: var(--text-muted, #64748b);\n}\n\n.support-message-chat-userid {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #ea580c;\n}\n\n.support-message-chat-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.support-message-btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.support-message-btn:hover {\n  opacity: 0.95;\n}\n\n.support-message-btn--close {\n  background: #dc2626;\n  color: #fff;\n}\n\n.support-message-btn--resolve {\n  background: #16a34a;\n  color: #fff;\n}\n\n.support-message-chat-body {\n  flex: 1;\n  padding: 1.25rem;\n  overflow-y: auto;\n  min-height: 200px;\n  max-height: 360px;\n}\n\n.support-message-chat-empty {\n  margin: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 0.9rem;\n  text-align: center;\n  padding: 2rem;\n}\n\n.support-message-bubble-wrap {\n  margin-bottom: 1rem;\n}\n\n.support-message-bubble-wrap--user {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.support-message-bubble-wrap--support {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.support-message-bubble {\n  max-width: 85%;\n  padding: 0.75rem 1rem;\n  border-radius: 12px;\n}\n\n.support-message-bubble--user {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n}\n\n.support-message-bubble--support {\n  background: #475569;\n  color: #fff;\n  border: none;\n}\n\n.support-message-bubble-label {\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 0.35rem;\n  color: var(--text-muted, #64748b);\n}\n\n.support-message-bubble--support .support-message-bubble-label {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.support-message-bubble-text {\n  margin: 0 0 0.35rem;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n.support-message-bubble-time {\n  font-size: 0.7rem;\n  color: var(--text-muted, #94a3b8);\n}\n\n.support-message-bubble--support .support-message-bubble-time {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.support-message-compose {\n  border-top: 1px solid #e2e8f0;\n  padding: 1rem 1.25rem;\n  background: #f8fafc;\n}\n\n.support-message-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-bottom: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.support-message-toolbar-select {\n  padding: 0.35rem 0.5rem;\n  font-size: 0.8rem;\n  font-family: inherit;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  margin-right: 0.5rem;\n}\n\n.support-message-toolbar-btn {\n  padding: 0.4rem 0.6rem;\n  font-size: 0.85rem;\n  color: #64748b;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.support-message-toolbar-btn:hover {\n  background: #f1f5f9;\n  color: #1e293b;\n}\n\n.support-message-textarea {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  resize: vertical;\n  min-height: 80px;\n  margin-bottom: 0.75rem;\n}\n\n.support-message-textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.support-message-send-wrap {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.support-message-btn-send {\n  padding: 0.6rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.support-message-btn-send:hover:not(:disabled) {\n  opacity: 0.95;\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n}\n\n.support-message-btn-send:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .support-message-layout {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
